import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type IconProp, type SizeProp } from '@fortawesome/fontawesome-svg-core';

type Props = {
  icon: IconProp,
  title?: string,
  text?: string,
  iconSize?: SizeProp
}

export default function EmptyState({ icon, title, text, iconSize }: Props) {
  return (
    <div className="empty">
      {icon && (
        <div className="empty-media">
          <FontAwesomeIcon className="icon-gradient" icon={icon} size={iconSize || 'lg'} />
        </div>
      )}
      {title && <h6 className="empty-title">{title}</h6>}
      {text && <div className="empty-content">{text}</div>}
    </div>
  );
}
